import {
	ApostropheProvider, Typography
} from '@apostrophe/ui'
import { get } from 'lodash';
import React from 'react';

import {
	Card,
	NewCheckoutCard,
	PrepayCard,
} from '../styles';

const getBrand = (brand) => {
	const brandMapping = {
		Visa: 'visa',
		'American Express': 'amex',
		MasterCard: 'mastercard',
		Discover: 'discover',
		JCB: 'jcb',
		'Diners Club': 'diners',
		Unknown: '',
		UnionPay: 'unionpay',
	}
	return get(brandMapping,
		brand,
		'Card');
}
const StripeUISelector = ({
	info,
	open,
	selected,
	outline,
	darkMode,
	medCheckout,
	isFollowupv2,
	isPrepay,
}) => {

	if (isPrepay) {
		return (
			<ApostropheProvider>
				<PrepayCard onClick={open}>
					<Typography weight="medium">
						<svg width="32" height="24" viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path fillRule="evenodd" clipRule="evenodd" d="M5.17296 4C3.5161 4 2.17296 5.34315 2.17296 7V17C2.17296 18.6569 3.5161 20 5.17296 20H19.173C20.8298 20 22.173 18.6569 22.173 17V7C22.173 5.34315 20.8298 4 19.173 4H5.17296ZM4.17296 7C4.17296 6.44772 4.62067 6 5.17296 6H19.173C19.7252 6 20.173 6.44772 20.173 7V9H4.17296V7ZM4.17296 11V17C4.17296 17.5523 4.62067 18 5.17296 18H19.173C19.7252 18 20.173 17.5523 20.173 17V11H4.17296Z" fill="black"/>
						</svg>
						{info.card_last_4 ? `•••• •••• •••• ${info.card_last_4}` : ' '}
					</Typography>
					<Typography weight="medium">{info.card_exp_month} / {String(info.card_exp_year).slice(-2)}&nbsp;&nbsp;&nbsp;•••</Typography>
				</PrepayCard>
			</ApostropheProvider>
		)
	}
	if (medCheckout) {
		return (
			<NewCheckoutCard medCheckout={medCheckout} selected={selected} outline={outline} onClick={open} darkMode={darkMode} style={{ width:'100%' }}>
				<div>
					<p style={{ marginBottom: '0' }}>{getBrand(info.card_brand).charAt(0).toUpperCase() + getBrand(info.card_brand).slice(1)} ending in {info.card_last_4 ? `${info.card_last_4}` : ' '}</p>
				</div>
				{info &&
          <div className="edit" onClick={()=> {logAmplitudeEvent('submit_page',
          	{ submit_page_actions: 'update_payment_method' })}}>
            Edit
          </div>
				}
			</NewCheckoutCard>
		);
	}
	return (
		<Card medCheckout={medCheckout} selected={selected} outline={outline} onClick={open} darkMode={darkMode} style={{ width:'100%' }}>
			<div>
				<div className="payment-label">Credit Card</div>
				<div className={`payment-method-icon ${getBrand(info.card_brand)}`}></div>
			</div>
			<div>
				<div className="payment-account">
					{info.card_last_4 ? `**** ${info.card_last_4}` : ' '}
				</div>
				{info &&
          <div className="edit">
            Edit
          </div>
				}
			</div>
		</Card>
	);
};

export default StripeUISelector
